import { SelectOption } from '@/shared/types';

import { SERVICE_CODES } from '@/lib/consts';

import { DocumentTypeCode, PurchaseItemIdMapping } from '@/api/types';
import { allAllowedToChoosePassportDocumentTypeCodes } from '@/components/Forms/constants';

export const SERVICE_CODE = SERVICE_CODES.PURCHASE;
export const STEP_NUMBER_TO_PAY = 10;
export const STEP_NUMBER_SIGN_UP = 9;
export const STEP_NUMBER_HEALTH_DATA = 4;
export const LEARNING_DOCUMENT_STEP_NUMBER = 3;
export const STEP_NUMBER_PERSONAL_AND_PASSPORT_DATA = 5;
export const HEALTH_DOC_STEP_NUMBER = 4;
export const STEP_NUMBER_PERSON_STATUS = 2;

export const MILITARY_STATUSES = [
  'cd2cac04-8c4c-40a1-8c55-92e66f511eef',
  'f235222a-1bd6-4f6f-9dc5-0db2cb893a59',
  'd0dec35f-8d0d-4c9c-af20-48cfe7c52e03',
];

export const ADDITIONAL_OBJECT_OF_PURCHASE_OPTIONS = (objectOfPurchaseId: string): SelectOption[] => [
  {
    id: objectOfPurchaseId,
    label: 'Придбання нової одиниці зброї',
  },
  {
    id: PurchaseItemIdMapping.WEAPONS_MAIN_PART,
    label: 'Основна частина до наявної (сумісної моделі) одиниці зброї',
  },
];

export const disallowedDocumentTypeCodesForAdditionalDocumentStep = [
  ...allAllowedToChoosePassportDocumentTypeCodes,
  DocumentTypeCode.MEDICAL_REFERENCE,
  DocumentTypeCode.TECHNICAL_CONDITION,
  DocumentTypeCode.TECHNICAL_REFERENCE,
  DocumentTypeCode.CERTIFICATION,
  DocumentTypeCode.WORK_REFERENCE,
  DocumentTypeCode.PAYMENT_REFERENCE,
];
